import styled from "styled-components";

export const TableScrollWrap = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;
